import React, { FC } from "react";
import { Typography, makeStyles } from "@material-ui/core";
import Error from "../Error";
import Loading from "../Loading";
import { IPieChartSegment } from "./types";
import PieChart from "./PieChart";

const useStyles = makeStyles(() => ({
  root: {
    padding: "24px 16px",
    height: 402,
    width: "100%",
    backgroundColor: "#FFFFFF",
    boxShadow: "0px 0px 8px #C2C9D682",
    borderRadius: 15,
    position: "relative",
    overflow: "hidden",
  },
  loading: {
    position: "absolute",
    top: 20,
  },
  title: {
    fontSize: 24,
    fontWeight: "bold",
    color: "#231F20",
    textAlign: "center",
  },
  pieChartContainer: {
    width: "100%",
    height: "calc(100% - 36px)",
  },
  error: {
    marginTop: 100,
  },
}));

interface IPieChartWidgetProps {
  data: IPieChartSegment[];
  isLoading: boolean;
  title: string;
}

const PieChartWidget: FC<IPieChartWidgetProps> = ({
  data,
  isLoading,
  title,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {isLoading && <Loading className={classes.loading} />}
      <Typography className={classes.title} component={"h2"}>
        {title}
      </Typography>
      {!!data.length && (
        <div className={classes.pieChartContainer}>
          <PieChart data={data} />
        </div>
      )}
      {!data.length && !isLoading && (
        <Error
          className={classes.error}
          fullHeight={false}
          icon={"search"}
          text={"You have no results for now."}
        />
      )}
    </div>
  );
};

export default React.memo(PieChartWidget);
